import * as colors from "./colors";
import { getTheme } from "./theme";
export * from "./theme";

export { colors };
export default getTheme;
